import {
  storageSave, storageQuery,
  sessionSave, sessionQuery
} from './storage'
const CryptoJS = require('@/utils/crypto-js').CryptoJS

// 业务相关相关
const AccountKey = 'TY-Account'
const PwdKey = 'TY-Act-tk'
const SmsCodeKey = 'TY-SmsCode'
const CarProductId = 'TY-CarProductId'
export const tyHelper = {
  getAccount: function () {
    let str = storageQuery(AccountKey)
    return str || ''
  },
  setAccount: function (str) {
    return storageSave(AccountKey, str)
  },
  getPwd: function () {
    let str = storageQuery(PwdKey)
    return str || ''
  },
  setPwd: function (str) {
    return storageSave(PwdKey, str)
  },
  getSmsCode: function () {
    let str = sessionQuery(SmsCodeKey)
    return str || ''
  },
  setSmsCode: function (str) {
    return sessionSave(SmsCodeKey, str)
  },
  getCarPId: function () {
    let str = storageQuery(CarProductId)
    return str || ''
  },
  setCarPId: function (str) {
    return storageSave(CarProductId, str)
  }
}

export const verifyHelper = {
  phone: function (str) {
    let reg = /^1[345789][0-9]{9}$/
    return reg.test(str)
  },
  pwd: function (str) {
    // let reg = /^.*(?=.{6,20})(?=.*\d{1,})(?=.*[a-zA-Z]{1,}).*$/
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,20}$/
    return reg.test(str)
  },
  email: function (str) {
    let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    return reg.test(str)
  },
  taxNo: function (str) {
    let reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/
    return reg.test(str)
  },
  number: function (str) {
    let reg = /^\d{1,}$/
    return reg.test(str)
  }
}

export const Ecb = {
  /**
 * [字符串加密函数]
 * @returns String
 */
  encrypt: function (text) {
    let encrypt = CryptoJS.TripleDES.encrypt(
      text,
      CryptoJS.enc.Utf8.parse('86b8be2eee5d4054bc8cdd74'), {
      mode: CryptoJS.mode.ECB, // ECB模式
      padding: CryptoJS.pad.Pkcs7 // padding处理
    }
    )
    let encryptData = encrypt.toString() // 加密完成后，转换成字符串
    return encryptData
  },
  /**
* [字符串解密函数]
* @returns String
*/
  decrypt: function (text) {
    let decrypt = CryptoJS.TripleDES.decrypt(
      text,
      CryptoJS.enc.Utf8.parse('86b8be2eee5d4054bc8cdd74'), {
      mode: CryptoJS.mode.ECB, // ECB模式
      padding: CryptoJS.pad.Pkcs7 // padding处理
    }
    )
    let decryptData = decrypt.toString(CryptoJS.enc.Utf8) // 加密完成后，转换成字符串
    return decryptData
  }
}

export const stringHelper = {
  phoneNumHidden: function (str = '', frontLen, endLen) {
    let len = str.length - frontLen - endLen
    let xing = ''
    for (let i = 0; i < len; i++) {
      xing += '*'
    }
    return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
  }
}

export function copyText(txt) {
  return new Promise((resolve, reject) => {
    if (window.navigator && navigator.clipboard) {
      navigator.clipboard.writeText(txt)
        .then(() => {
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    } else {
      try {
        let input = document.createElement('input')
        input.setAttribute('readonly', 'readonly')
        input.setAttribute('value', txt)
        document.body.appendChild(input)
        input.select()
        let cRes = document.execCommand('copy')
        document.body.removeChild(input)
        if (cRes) {
          resolve()
        } else {
          reject(new Error('复制失败'))
        }
      } catch (err) {
        reject(err)
      }
    }
  })
}

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (s1, s2) {   // eslint-disable-line
    return this.replace(new RegExp(s1, 'gm'), s2)
  }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js